import React from 'react';
import ReferencesList from '@/components/References/ReferencesList';

interface ListSectionProps {
  selectedTags: string[];
  searchTerm?: string;
}

const ListSection = ({ selectedTags, searchTerm }: ListSectionProps) => {
  return <ReferencesList selectedTags={selectedTags} searchTerm={searchTerm} />;
};

export default ListSection; 